import React, { Fragment } from "react";
import classNames from "classnames";
import { isSplit } from "shared/utils/validation";
import { calculateScoreDifferences } from "./utils";

import styles from "./styles.module.scss";

export default function PBAScoreFull({ players, numberOfPlayers }) {
  const size = players.size;
  const scoreDifferences = calculateScoreDifferences(players);

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tr_title}>
            <td colSpan="11"></td>
          </tr>
          <tr className={styles.tr_thead}>
            {Array.from({ length: 11 }).map((_, index) => (
              <td key={`header-${index}`}>{index > 0 ? index : null}</td>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from(players)
            .slice(0, numberOfPlayers)
            .map(([key, player], rowIndex) => (
              <Fragment key={key}>
                <tr>
                  <td className={styles.td_body_first}>
                    <div className={styles.td_body_first_container}>
                      <p className={styles.player_name}>{player.playerName}</p>
                      {rowIndex < size - 1 && (
                        <span>{scoreDifferences[rowIndex]}</span>
                      )}
                    </div>
                  </td>
                  {Array.from({ length: 10 }).map((_, colIndex) => (
                    <RenderScore
                      key={colIndex}
                      throws={player.throws}
                      index={colIndex}
                      pins={player.pins}
                    />
                  ))}
                </tr>
                <tr>
                  <td className={styles.td_body_second}>
                    MAX SCORE
                    <span>{player.maxScore}</span>
                  </td>
                  {player.scores.map((score, index) => (
                    <td key={index}>{score}</td>
                  ))}
                  {Array.from({ length: 10 - player.scores.length }).map(
                    (_, i) => (
                      <td key={`empty-${i}`}></td>
                    ),
                  )}
                </tr>
              </Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
}

const RenderScore = ({ throws, index, pins }) => {
  const firstThrow = throws[index * 2];
  const secondThrow = throws[index * 2 + 1];
  const firstPin = pins[index * 2];
  const secondPin = pins[index * 2 + 1];

  if (!firstThrow && !secondThrow) return <td></td>;

  return (
    <td className={styles.td_render_score}>
      <span className={styles.render_score}>
        <StrikeOrSpare
          score={firstThrow}
          isTenthFrame={throws.length >= 19}
          isSplit={isSplit(firstPin)}
        />
        {secondThrow && (
          <StrikeOrSpare
            score={secondThrow}
            isTenthFrame={throws.length >= 19}
            isSplit={isSplit(secondPin)}
          />
        )}
      </span>
    </td>
  );
};

const StrikeOrSpare = ({ score, isTenthFrame, isSplit = false }) => {
  if (score === "X")
    return <span style={{ width: isTenthFrame ? "50%" : "100%" }}>X</span>;
  if (score === "/") return <span className={styles.spare}>/</span>;
  return (
    <span className={classNames(styles.throw, { [styles.is_split]: isSplit })}>
      {score}
    </span>
  );
};
